import axios from 'axios';
import config from '../config';
import { _apiHeaderConfigs } from "../components/utils/APIsUtils/httpsUtils";

const { currentRegion, currentEnv } = config;
const CURRENTENV = currentEnv.toLowerCase();
const { apiConfig } = config[currentRegion];
const BASE_URL = apiConfig[CURRENTENV].baseURL;

export default class BannerService {

    static async createBanner(formData) {
        try {
            const _headers = await _apiHeaderConfigs();

            const response = await axios.post(
                `${BASE_URL}/admin/api/v1/banners`,
                formData,
                {
                    headers: {
                        authorization: _headers._accessToken,
                        profile: _headers._idToken,
                        // Don't set Content-Type for FormData - browser will set it with boundary
                    },
                }
            );

            // Return full response to access status code
            return {
                status: response.status,
                data: response.data,
            };
        } catch (error) {
            // Check if it's a 207 Multi-Status (partial success)
            if (error.response?.status === 207) {
                return {
                    status: 207,
                    data: error.response.data,
                };
            }

            // Re-throw for other errors to be handled by caller
            throw error;
        }
    }

    static async getBannerById(bannerId) {
        const _headers = await _apiHeaderConfigs();

        const response = await axios.get(
            `${BASE_URL}/admin/api/v1/banners/${bannerId}`,
            {
                headers: {
                    authorization: _headers._accessToken,
                    profile: _headers._idToken,
                },
            }
        );

        return {
            status: response.status,
            data: response.data,
        };
    }

    static async unlocalizeTranslation(bannerId, locale) {
        const _headers = await _apiHeaderConfigs();

        const response = await axios.post(
            `${BASE_URL}/admin/api/v1/banners/${bannerId}/translations/unlocalize?locale=${encodeURIComponent(locale)}`,
            null,
            {
                headers: {
                    authorization: _headers._accessToken,
                    profile: _headers._idToken,
                },
            }
        );

        return {
            status: response.status,
            data: response.data,
        };
    }

    static async updateBanner(bannerId, formData) {
        try {
            const _headers = await _apiHeaderConfigs();

            const response = await axios.put(
                `${BASE_URL}/admin/api/v1/banners/${bannerId}`,
                formData,
                {
                    headers: {
                        authorization: _headers._accessToken,
                        profile: _headers._idToken,
                        // Don't set Content-Type for FormData - browser will set it with boundary
                    },
                }
            );

            // Return full response to access status code
            return {
                status: response.status,
                data: response.data,
            };
        } catch (error) {
            // Check if it's a 207 Multi-Status (partial success)
            if (error.response?.status === 207) {
                return {
                    status: 207,
                    data: error.response.data,
                };
            }

            // Re-throw for other errors to be handled by caller
            throw error;
        }
    }
}
